import { useNavigate } from 'react-router-dom'

import { ItemForm } from '@/components/ItemForm'
import { errorMessage } from '@/lib/pb'
import { useCreateItem } from '@/lib/queries'

export function ItemNew() {
  const navigate = useNavigate()
  const create = useCreateItem()

  return (
    <div className="space-y-4">
      <h1 className="text-lg font-semibold text-ink">Add a record</h1>
      <ItemForm
        submitLabel="Save record"
        busy={create.isPending}
        error={create.error ? errorMessage(create.error) : undefined}
        onCancel={() => navigate(-1)}
        onSubmit={({ input }) => create.mutate({ input }, { onSuccess: () => navigate('/') })}
      />
    </div>
  )
}
